/* eslint-disable import/order */
import { useState } from 'react'

import { updateOwner } from 'store/owners/actions'
import type { UpdateOwnerPayload } from 'store/owners/types'
import { useDispatch } from 'store/hooks'

import { Owner } from 'store/owners/types'

type UseOwnerUpdateMutationsResult = [
  {
    updateOwner: (payload: UpdateOwnerPayload) => void
  },
  {
    data?: Owner
    isLoading: boolean
    isError: boolean
  }
]

type UseOwnerUpdateMutationsOptions = {
  onSuccess?: (data?: any) => void
  onError?: (error?: any) => void
}

type UpdateOwnerFields = UpdateOwnerPayload

export const useOwnerUpdateMutations = (options?: UseOwnerUpdateMutationsOptions): UseOwnerUpdateMutationsResult => {
  const dispatch = useDispatch()

  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const updateOwnerFn = (payload: UpdateOwnerFields) => {
    setIsLoading(true)
    setIsError(false)

    dispatch(
      updateOwner(payload, ({ success, content }: any) => {
        setIsLoading(false)

        if (success) {
          setData(content)

          if (!options) {
            return
          }

          if (options.onSuccess) {
            options.onSuccess(content)
          }
        } else {
          setIsError(true)

          if (!options) {
            return
          }

          if (options.onError) {
            options.onError(content)
          }
        }
      })
    )
  }

  return [{ updateOwner: updateOwnerFn }, { data, isLoading, isError }]
}
